import { render } from "./AbtestMessageResultPage.vue?vue&type=template&id=327382b1"
import script from "./AbtestMessageResultPage.vue?vue&type=script&lang=js"
export * from "./AbtestMessageResultPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__